var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"city-avatar",attrs:{"adcode-prefix":_vm.adcode.toString().slice(0, 2)}},[_c('span',{staticClass:"city-name",class:[{ reduce: _vm.cityName.length > 3 }]},[_vm._v(_vm._s(_vm.cityName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }